@if (!budget) {
  <div class="loader"></div>
}
@if (budget) {
  <div>
    @switch (budget.poolModel.line) {
      @default {
        <app-budget-model-1
          [budget]="budget"
          [fundingInstallmentsTemp]="fundingInstallmentsTemp"
          [optionalAccessoriesTemp]="optionalAccessoriesTemp"
          [installationMaterialsTemp]="installationMaterialsTemp"
          [interestForm]="interestForm"
          [day]="day"
          [month]="month"
          [year]="year"
          [isCompleted]="isCompleted"
        ></app-budget-model-1>
      }
      @case ('FINESA') {
        <app-budget-model-finesa
          [budget]="budget"
          [fundingInstallmentsTemp]="fundingInstallmentsTemp"
          [optionalAccessoriesTemp]="optionalAccessoriesTemp"
          [installationMaterialsTemp]="installationMaterialsTemp"
          [interestForm]="interestForm"
          [day]="day"
          [month]="month"
          [year]="year"
          [isCompleted]="isCompleted"
        ></app-budget-model-finesa>
      }
      @case ('LAGUNE') {
        <app-budget-model-lagune
          [budget]="budget"
          [fundingInstallmentsTemp]="fundingInstallmentsTemp"
          [optionalAccessoriesTemp]="optionalAccessoriesTemp"
          [installationMaterialsTemp]="installationMaterialsTemp"
          [interestForm]="interestForm"
          [day]="day"
          [month]="month"
          [year]="year"
          [isCompleted]="isCompleted"
        ></app-budget-model-lagune>
      }
    }
  </div>
}
